/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_ShowInputs */

const en_auth_password_show = /** @type {(inputs: Auth_Password_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show password`)
};

/**
* | output |
* | --- |
* | "Show password" |
*
* @param {Auth_Password_ShowInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_password_show = /** @type {((inputs?: Auth_Password_ShowInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_ShowInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_password_show(inputs)
});